import { sanityClient } from '../lib/sanityClient';
import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';

/**
 * Hook to query Sanity via ReactQuery library.
 * Params and return types are the same as ReactQuery's useQuery hook.
 */
export const useSanityQuery = <T>(options: UseQueryOptions<T>): UseQueryResult<T> => {
  return useQuery<T>({
    ...options,
    queryFn: ({ queryKey }) => {
      return sanityClient.fetch<T>(queryKey[0] as string);
    },
  });
};
